import React from 'react';
import './Icon.css';

const Icon = ({ 
  name, 
  variant = 'outlined', 
  size = 'medium', 
  color = 'inherit',
  className = '',
  ...props 
}) => {
  const getVariantClass = (variant) => {
    const variants = {
      outlined: 'material-symbols-outlined',
      rounded: 'material-symbols-rounded',
      sharp: 'material-symbols-sharp'
    };
    return variants[variant] || variants.outlined;
  };

  const getSizeClass = (size) => {
    const sizes = {
      small: 'icon-small',
      medium: 'icon-medium',
      large: 'icon-large',
      xlarge: 'icon-xlarge'
    };
    return sizes[size] || sizes.medium;
  };

  const iconClass = [
    getVariantClass(variant),
    getSizeClass(size),
    className
  ].filter(Boolean).join(' ');

  return (
    <span 
      className={iconClass}
      style={{ color }}
      {...props}
    >
      {name}
    </span>
  );
};

export default Icon;
